





















import { defineComponent } from "@vue/composition-api";

export default defineComponent({
	props:{
		value:{
			type:String,
		},
	},
	setup(){
		
		const options = [
			{
				value:"en",
				text:"English",
				flag:"/icons/flag-gb.svg",
			},
			{
				value:"is",
				text:"Íslenska",
				flag:"/icons/flag-is.svg",
			},
		];

		return {
			options,
		};
	}
});

